import React, { useState } from 'react';

export function SafetyPanel({ matchId, playerToken, lobbyUrl }) {
    const [reason, setReason] = useState('offensive_name');
    const [busy, setBusy] = useState(false);
    const [message, setMessage] = useState('');
    const [confirming, setConfirming] = useState(false);
    const send = async (action) => {
        setBusy(true);
        setMessage('');
        try {
            const response = await fetch(`/api/v1/matches/${matchId}/${action}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Secret-Digits-Web': '1', ...(playerToken ? { Authorization: `Bearer ${playerToken}` } : {}) },
                body: JSON.stringify(action === 'reports' ? { reason } : {}),
                signal: AbortSignal.timeout(10000),
            });
            const payload = await response.json().catch(() => ({}));
            if (!response.ok || payload.accepted !== true) throw new Error(payload.message || '送信できませんでした。通信を確認して再試行してください。');
            if (action === 'block') window.location.assign(lobbyUrl);
            else setMessage('通報を受け付けました。運営が確認します。現在の接触も止める場合はブロックしてください。');
        } catch (error) {
            setMessage(error.message || '送信できませんでした。');
        } finally { setBusy(false); }
    };
    return <section className="text-sm" aria-label="相手への安全対策">
        <details className="rounded-xl border" onToggle={(event) => { if (!event.currentTarget.open) setConfirming(false); }}>
            <summary className="min-h-11 cursor-pointer px-4 py-3 font-semibold">通報・ブロック</summary>
            <div className="border-t px-4 pb-4 pt-2">
                <h2 className="font-bold">相手を通報・ブロック</h2>
                <p className="mt-2 text-sm">通報は相手の表示名と定型理由を7日間保存します。秘密数字や対戦履歴は含みません。</p>
                <label className="mt-3 block">通報理由
                    <select value={reason} onChange={(event) => setReason(event.target.value)} className="ml-2 rounded border p-2" disabled={busy}>
                        <option value="offensive_name">不適切な表示名</option><option value="harassment">嫌がらせ・脅迫</option>
                        <option value="personal_information">個人情報の掲載</option><option value="other">その他の不適切な利用</option>
                    </select>
                </label>
                <div className="mt-3 flex flex-wrap gap-3">
                    <button type="button" className="rounded border px-3 py-2" disabled={busy} onClick={() => send('reports')}>通報を送信</button>
                    <button type="button" className="rounded border px-3 py-2" disabled={busy} onClick={() => setConfirming(true)}>このルームで相手をブロック</button>
                </div>
                {confirming && <div className="mt-3 rounded border p-3" role="group" aria-label="ブロックの確認">
                    <p>両者が退出し、このルームへの再接続・再戦を停止します。別のルームや新しいID・端末での接触は防げません。招待は信頼する相手だけに共有してください。</p>
                    <button type="button" className="mt-2 rounded border px-3 py-2" disabled={busy} onClick={() => send('block')}>ブロックして退出</button>
                    <button type="button" className="ml-3 rounded border px-3 py-2" disabled={busy} onClick={() => setConfirming(false)}>キャンセル</button>
                </div>}
                <a href="/support" className="mt-3 inline-block min-h-11 py-3 underline">運営への問い合わせ</a>
            </div>
        </details>
        {message && <p role="status" className="mt-3 text-sm">{message}</p>}
    </section>;
}
